import './add_infos_toBill.css'
import React, { useState } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import {makeStyles} from '@mui/styles';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import PaymentIcon from '@mui/icons-material/Payment';
import InputAdornment from '@mui/material/InputAdornment';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import DoneIcon from '@mui/icons-material/Done';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';

import { add_infos_torequest_order_Bill, add_infos_toBill,add_infos_to_contract_Bill } from '../../../../services/finance_service';


const useStyles = makeStyles((theme) => ({
    button: { margin: 8,},
    root: {
      '& > *': {
        margin: 8,
      },
    }
  }));

function setDateTime(date){
    let day = date.toISOString();
    let day_comp = day.split(":");
    return day_comp[0];
}
  

function Add_infos_toBill({open_addInfo_toBill_modal,setOpen_addInfo_toBill_modal,id_submission,request_code,id_contract,bills_numbers,markets,setMarkets,verify_amount}){

    const classes = useStyles();

    const [errorText,setErrorText] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [waiting, setWaiting] = useState(false);

    const [block_to_submit,setBlock_to_submit] = useState(false);

    const [expiration_date,setExpiration_date]=useState('');
    const [amount_without_tax,setAmount_without_tax]=useState('');


  function submit_refuse_reason() {
    setSubmitted(true);
    setErrorText("");
    if(expiration_date==='' || amount_without_tax===''){
      setErrorText("Champ vide !");
    }else{
        setWaiting(true);
        let formData = new FormData();
        if(request_code) formData.append('request_code',request_code);
        else if(id_contract) formData.append('id_contract',id_contract);
        else formData.append('id_submission',id_submission);
        formData.append('bills_numbers',JSON.stringify(bills_numbers));
        formData.append('expiration_date',expiration_date);
        formData.append('amount_without_tax',amount_without_tax);
        
        if(request_code){
          add_infos_torequest_order_Bill(formData).then((response)=>{
              //console.log(response.data);
              let tmp_array = [...markets];
              tmp_array[open_addInfo_toBill_modal].bills = response.data;
              setMarkets(tmp_array);
              setOpen_addInfo_toBill_modal(null);
              setWaiting(false);
          }).catch((error)=>{
              setWaiting(false);
              //console.log(error.response);
          })
        }else if(id_contract){
          add_infos_to_contract_Bill(formData).then((response)=>{
              //console.log(response.data);
              let tmp_array = [...markets];
              tmp_array[open_addInfo_toBill_modal].bills = response.data;
              setMarkets(tmp_array);
              setOpen_addInfo_toBill_modal(null);
              setWaiting(false);
          }).catch((error)=>{
              setWaiting(false);
              //console.log(error.response);
          })
        }
        else{
          add_infos_toBill(formData).then((response)=>{
              //console.log(response.data);
              let tmp_array = [...markets];
              tmp_array[open_addInfo_toBill_modal].bills = response.data;
              setMarkets(tmp_array);
              setOpen_addInfo_toBill_modal(null);
              setWaiting(false);
          }).catch((error)=>{
              setWaiting(false);
              //console.log(error.response);
          })
        }

        
    }
        
     }

    function on_amount_change(value){
      const int_value = value!=""?parseFloat(value,2):0;
      setAmount_without_tax(value);
      const is_it_good = verify_amount(open_addInfo_toBill_modal,bills_numbers[0],int_value);
      if(is_it_good!=true){
        setSubmitted(true);
        setErrorText(is_it_good);
        setBlock_to_submit(true);
      }
      else{
        setSubmitted(false);
        setErrorText("");
        setBlock_to_submit(false);
      }
    }

    return (
      <Dialog fullWidth={true} maxWidth={'md'} open={open_addInfo_toBill_modal!=null?true:false} onClose={()=>setOpen_addInfo_toBill_modal(null)} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-title">Informations Facture N°{bills_numbers[0]}</DialogTitle>
        <DialogContent>
          <div className='add_infos_toBill_container'>  
            
            <TextField variant='standard' className={classes.margin} label="Montant hors taxe (DH) " type="number" style={{width:"250px"}}
                  InputProps={{ startAdornment: ( <InputAdornment position="start"> <PaymentIcon /> </InputAdornment> ), }} onChange={(e)=>on_amount_change(e.target.value)} />
            
            <TextField
                    type="date" variant="standard"
                    className={classes.margin} label="Date d'échéance" min={new Date().toDateString()} style={{width:"250px"}}
                    InputProps={{ startAdornment: ( <InputAdornment position="start"> <EventBusyIcon /> </InputAdornment> )}} onChange={(e)=>setExpiration_date(e.target.value)}
                />
                
          </div>
          
     </DialogContent>
        <DialogActions>
          <div className='dialogBottom'>
            <div>
            {
                errorText == "" 
                ?<></>
                :<p className={submitted ? "error" : "valid-champ"}>
                        {errorText}
                    </p>
            }
            </div>
            <div>
              <Button variant="contained" className="submit_but cancel_but" startIcon={<CancelIcon />} onClick={()=>setOpen_addInfo_toBill_modal(null)} >
                  Annuler
              </Button>
              <Button variant="contained" className={block_to_submit==true?"submit_but valide_but disabled_button":"submit_but valide_but"} startIcon={<DoneIcon />} onClick={submit_refuse_reason} >
                  Valider
              </Button> 
            </div>
          </div>
        </DialogActions>

        <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

      </Dialog>
    )
}

export default Add_infos_toBill
